import confetti from 'canvas-confetti';

export interface ConfettiBurstConfig {
  originX?: number;
  originY?: number;
  zIndex?: number;
  particleCount?: number;
}

const DEFAULT_CONFIG: Required<ConfettiBurstConfig> = {
  originX: 0.5,
  originY: 0.2,
  zIndex: 1500,
  particleCount: 200
};

export function fireConfettiBurst(config: ConfettiBurstConfig = {}): void {
  const { originX, originY, zIndex, particleCount } = { ...DEFAULT_CONFIG, ...config };
  const defaults: confetti.Options = { origin: { x: originX, y: originY }, zIndex };

  const fire = (particleRatio: number, opts: confetti.Options) => {
    confetti({ ...defaults, ...opts, particleCount: Math.floor(particleCount * particleRatio) })
      ?.catch((error: unknown) => { console.error('Failed to render confetti:', error); });
  };

  fire(0.25, { spread: 26, startVelocity: 55 });
  fire(0.2, { spread: 60 });
  fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
  fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
  fire(0.1, { spread: 120, startVelocity: 45 });
}
